import moment from 'moment/moment'
import { mixins } from '@/mixins'

export const timestampInSecondsToDDMMYYYY = (timestamp, separator = '.') => {
  timestamp = Number.isInteger(timestamp) ? timestamp : parseInt(timestamp)
  const date = timestamp ? moment(timestamp * 1000) : moment()
  return date.format(`DD${separator}MM${separator}YYYY`)
}

export const secondsToHumanReadableTime = (timestamp, withSeconds = true) => {
  if (timestamp) {
    let hours = Math.floor(
      parseFloat(mixins.methods.formatPrice(timestamp / 60 / 60, false))
    )
    let minutes = Math.round(
      parseFloat(mixins.methods.formatPrice(timestamp / 60, false))
      - parseFloat(mixins.methods.formatPrice(hours * 60, false))
    )
    let seconds = Math.round(parseFloat(mixins.methods.formatPrice(timestamp % 60, false)))
    const parts = []
    if (hours) {
      parts.push(`${hours} ч.`)
      if (minutes) {
        parts.push(`${minutes} мин.`)
      }
      if (withSeconds) {
        parts.push(`${seconds} сек.`)
      }
    } else if (minutes) {
      parts.push(`${minutes} мин.`)
      if (withSeconds) {
        parts.push(`${seconds} сек.`)
      }
    } else if (withSeconds) {
      parts.push(`${seconds} сек.`)
    }
    return parts.join(' ')
  }
  return null
}

export const formatDateAsTodayYesterdayOrOther = date => {
  date = date ? parseInt(date) : ''
  if (date) {
    date = moment(date)
    if (date.isSame(new Date(), 'day')) {
      date = `Сегодня, ${date.format('HH:mm')}`
    } else {
      if (date.isSame(moment().subtract(1, 'days'), 'day')) {
        date = `Вчера, ${date.format('HH:mm')}`
      } else {
        date = date.format('DD.MM.YYYY HH:mm')
      }
    }
  }
  return date
}